/**
 * Represents the default debounce time in milliseconds for search queries.
 * This is used to limit the number of requests sent to the server while the user is typing
 * in a search input, improving performance and reducing server load.
 */
export const QUERY_SEARCH_DEBOUNCE_IN_MS = 200;
